// if (!window.fetch) {
//   window.fetch = require('isomorphic-fetch');
// }
// if (!window.Promise) {
//   window.Promise = require('bluebird');
// }
var shopifyIntegrationServiceBaseUrl = process.env.NEXT_PUBLIC_SHOPIFYINTEGRATION_SERVICE_BASE_URL;
var assetPath = process.env.NEXT_PUBLIC_ASSET_PATH;
var assetRoutePrefix = process.env.NEXT_PUBLIC_ASSET_ROUTE_PREFIX;

if (!assetRoutePrefix || assetRoutePrefix.substring(1) === '{ASSET_ROUTE_PREFIX}') {
  assetRoutePrefix = process.env.ASSET_ROUTE_PREFIX || '/shopifyintegration'; // this is a required fallback (specific to this app), because of how var substitution is set up here
}

var serviceName = process.env.NEXT_PUBLIC_DD_SERVICE;
var debugVersion = process.env.NEXT_PUBLIC_DEBUG_VERSION;
var currentEnvironment = process.env.NEXT_PUBLIC_CURRENT_ENVIRONMENT;
module.exports = {
  app: 'shopifyintegration',
  shopifyIntegrationServiceBaseUrl: shopifyIntegrationServiceBaseUrl,
  assetRoutePrefix: assetRoutePrefix,
  assetPath: assetPath,
  serviceName: serviceName,
  debugVersion: debugVersion,
  currentEnvironment: currentEnvironment
};